<script setup lang="ts">
import { RouterView } from 'vue-router';
</script>

<template>
	<div class="flex min-h-dvh w-full flex-col">
		<RouterView />
	</div>
</template>
